import React from "react";
import { Sidebar, Menu, SubMenu, MenuItem, sidebarClasses} from "react-pro-sidebar";
import logo from "../assets/icons/logo.svg";
import { Link, useLocation } from "react-router-dom";

// function classNames(...classes) {
//   return classes.filter(Boolean).join(" ");
// }

function CustomSidebar({ setOpen, open }) {
  const location = useLocation();
  const navigation = [
    { name: "Dashboard", route: "/dashboard" },
    { name: "Check Odd", route: "/check-odd" },
    { name: "Different Odd", route: "/diff-odd" },
    { name: "Match Event", route: "/match-event" },
    { name: "Result", route: "/goal-result" },
    { name: "Limit", route: "/gambling-limit" },
    { name: "Reports", route: "/diff-odd-vouchers", 
      subMenu: [
        {name: "By Event", route: '/report-byevent'},
        {name: "By Mix", route: '/report-bymix'},
        {name: "By User", route: '/report-byuser'},
        {name: "By Purchased", route: '/report-bypurchased'},
        {name: "By Reject", route: '/report-byreject'},
      ] 
    },
    { name: "User Transaction", 
      subMenu: [
        {name: "By Date", route: '/transaction-bydate'},
      ] 
    },
    { name: "Admin Authority", 
      subMenu: [
        { name: "By Voucher", route: '/by-voucher' },
      ] 
    },
  ];
  const menuItemStyles = {
    root: {
      fontSize: "15px",
      fontWeight: 400,
    },

    icon: {
      color: "#000",
    },

    subMenuContent: ({ level }) => ({
      backgroundColor: level === 0 ? "rgba(41,46,76, 0.5)" : "transparent",
    }),
    button: {
      "&:hover": {
        backgroundColor: "rgba(41,46,76, 0.5)",
        color: "#ECF0F3",
      },
    },
    label: ({ open }) => ({
      fontWeight: open ? 600 : undefined,
    }),
  };
  return (
    <Sidebar
      backgroundColor={"rgba(41,46,76,0.8)"}
      // image="side.jpg"
      onBackdropClick={() => setOpen(() => !open)}
      toggled={open}
      breakPoint="all"
      transitionDuration={1000}
      rootStyles={{
        color: "#fff",
        [`.${sidebarClasses.container}::-webkit-scrollbar `]: {
          display: "none"
        },
      }}
      className="no-scrollbar"
    >
      <div
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
        className=" backdrop-blur-sm no-scrollbar"
      >
        <div style={{ flex: 1 }}>
          <div className="flex justify-center align-middle mt-2">
            <img src={logo} className="App-logo mt-5 mb-1 w-14" alt="logo" />
          </div>
          <div className="flex justify-center align-middle mb-5">ADMIN PANEL</div>
          <Menu menuItemStyles={menuItemStyles}>
            {navigation.map((item,i) => (
            <>
              {
                item.subMenu ?
                    <SubMenu label={item.name}  className="last-child:pb-32" key={i}>
                      {item.subMenu.map(( el )=>  
                                <MenuItem key={el.name}>
                                  <Link key={el.name} 
                                        to={el.route}
                                        className={`${location.pathname === el.route ? "bg-background/[0.5]" : ""
                                          } rounded-md px-3 py-2 text-sm font-medium w-full h-full flex text-gray-300 hover:text-white`}
                                  >
                                      {el.name}
                                  </Link>
                                </MenuItem>
                                )
                      }    
                   </SubMenu>
              :
              (
                <MenuItem className="-ml-3"> 
                     <Link key={item.name}
                           to={item.route}
                     
                      className={`${location.pathname === item.route ? "bg-background/[0.5]" : ""
                        } rounded-md px-3 py-2 text-sm font-medium w-full h-full flex text-gray-300 hover:text-white`}
                      >
                        <span>
                          {item.name}
                        </span>
                       </Link>    
                </MenuItem>
              )
              }
            </>
            ))}
          </Menu>
        </div>
      </div>
    </Sidebar>
  );
}

export default CustomSidebar;
